import React from "react";
import "../../GlobalCss/SPF/1099Table.css"
import { useState, useEffect } from "react";
import { Form, Input, Popconfirm, Table, Typography, Button, Modal, Spin, Image, DatePicker } from 'antd';
import {
    SendOutlined, EditOutlined, CheckOutlined, CloseOutlined, PlusOutlined, DeleteOutlined, ExclamationCircleOutlined,
    SearchOutlined
} from "@ant-design/icons";
import { getAccountsCubeData, updateAccountingCubeRow } from "../../Repository/TenNinetyNineRepository";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const TenNinetyNineTable = ({ tableLoader, griddata, setGriddata }) => {
    const originalData = griddata;
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [rowData, setRowData] = useState([]);
    const [oldData, setOldData] = useState([]);
    const [searchRow, setSearchRow] = useState("")
    const [filteredData, setFilteredData] = useState(griddata);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedId, setSelectedId] = useState([])
    const [NewRecordKey, setNewRecordKey] = useState(null);
    const [fromDate, setFromDate] = useState()
    const [toDate, setTodate] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [cols, setCols] = useState(true)
    const [allCols, setAllCols] = useState(false)

    const isEditing = (record) => record.Id === editingKey;
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.First_Name)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Last_Name)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Portal).toLowerCase().includes(value.toLowerCase()) ||
                String(record.Worker_code).toLowerCase().includes(value.toLowerCase()) ||
                String(record.Contract_Vendor_Name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });
    const changeStartDate = (e) => {
        let sample = new Date(e)
        const stripTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
        if (e !== null) {
            const day = String(sample.getDate()).padStart(2, '0');
            const month = String(sample.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = sample.getFullYear();
            const formattedDate = `${month}/${day}/${year}`;
            const value = dayjs(formattedDate, 'MM/DD/YYYY');
            if (toDate !== undefined) {
                let temp = new Date(toDate)
                const sampleDateOnly = stripTime(new Date(sample));
                const tempDateOnly = stripTime(new Date(temp));
                if (sampleDateOnly <= tempDateOnly) {
                    setFromDate(value)
                    setStartDate(sample)
                }
                else if (fromDate !== undefined) {
                    setFromDate(fromDate)
                    InfoMessage("Project start date should not be greater than Project end date")
                }
                else {
                    setFromDate("")
                    InfoMessage("Project start date should not be greater than Project end date")
                }
            }
            else if (toDate === undefined) {
                setFromDate(value)
                setStartDate(sample)
            }
        }
        else {
            setFromDate()
            setStartDate()
        }
    }
    const changeEndDate = (e) => {
        let sample = new Date(e)
        const stripTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
        if (e !== null) {
            const day = String(sample.getDate()).padStart(2, '0');
            const month = String(sample.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = sample.getFullYear();
            const formattedDate = `${month}/${day}/${year}`;
            const value = dayjs(formattedDate, 'MM/DD/YYYY');
            if (fromDate !== undefined) {
                let temp = new Date(fromDate)
                const sampleDateOnly = stripTime(new Date(sample));
                const tempDateOnly = stripTime(new Date(temp));
                if (sampleDateOnly >= tempDateOnly) {
                    setTodate(value)
                    setEndDate(sample)
                }
                else if (toDate !== undefined) {
                    setTodate(toDate)
                    InfoMessage("Project end date should be greater than Project start date")
                }
                else {
                    setTodate("")
                    InfoMessage("Project end date should be greater than Project start date")
                }
            }
            else if (fromDate === undefined) {
                setTodate(value)
                setEndDate(sample)
            }
        }
        else {
            setTodate()
            setEndDate()
        }
    }
    const columns =
        allCols ? [{
            title: 'ENTITY',
            key: 'Entity',
            dataIndex: 'Entity',
            width: 150,
            editable: true,
        },
        {
            title: 'CONTRACT VENDOR NAME',
            key: 'Contract_Vendor_Name',
            dataIndex: 'Contract_Vendor_Name',
            editable: true,
            width: 250,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            ),
            ...filterProps()
        },
        {
            title: 'PORTAL',
            key: 'Portal',
            dataIndex: 'Portal',
            editable: true,
            width: 190,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            ),
        },
        {
            title: 'FIRST NAME',
            key: 'First_Name',
            dataIndex: 'First_Name',
            editable: true,
            width: 200,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'MIDDLE NAME',
            key: 'Middle_Name',
            dataIndex: 'Middle_Name',
            editable: true,
            width: 200,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'LAST NAME',
            key: 'Last_Name',
            dataIndex: 'Last_Name',
            editable: true,
            width: 150,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'TIME SHEET NAME',
            key: 'Timesheer_Name',
            dataIndex: 'Timesheet_Name',
            editable: true,
            width: 180,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'PROJECT START',
            key: 'Project_Start',
            width: 180,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <DatePicker value={fromDate} onChange={changeStartDate} format={"MM-DD-YYYY"} />
                    </span>
                ) : (
                    <div>
                        {record.Project_Start}
                    </div>
                );
            },
        },
        {
            title: 'PROJECT END',
            key: 'Project_End',
            width: 180,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <DatePicker value={toDate} onChange={changeEndDate} format={"MM-DD-YYYY"} />
                    </span>
                ) : (
                    <div>
                        {record.Project_End}
                    </div>
                );
            },
        },
        {
            title: 'NET',
            key: 'Net',
            dataIndex: 'Net',
            editable: true,
            width: 180
        },
        {
            title: 'PAY RATE',
            key: 'Pay_rate',
            dataIndex: 'Pay_rate',
            editable: true,
            width: 180
        },
        {
            title: 'OT PAY RATE',
            key: 'OT_Payrate',
            dataIndex: 'OT_Payrate',
            editable: true,
            width: 180
        },
        {
            title: 'METHOD OF PAYMENT',
            key: 'Method_of_Payment',
            dataIndex: 'Method_of_Payment',
            editable: true,
            width: 180
        },
        {
            title: 'CURRENCY',
            key: 'Currency',
            dataIndex: 'Currency',
            editable: true,
            width: 180
        },
        {
            title: 'VENDOR CODE',
            key: 'Vendor_Code',
            dataIndex: 'Vendor_Code',
            editable: true,
            width: 200,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            ),
        },
        {
            title: 'LEDGER CODE',
            key: 'Ledger_Code',
            dataIndex: 'Ledger_Code',
            editable: true,
            width: 200,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            ),
        },
        // {
        //     title: 'MAIN ACCOUNT',
        //     key: 'Main_Account',
        //     dataIndex: 'Main_Account',
        //     editable: true,
        //     width: 180
        // },
        {
            title: 'BUSINESS UNIT',
            key: 'BusinessUnit',
            dataIndex: 'BusinessUnit',
            editable: true,
            width: 180
        },
        {
            title: 'DEPARTMENT',
            key: 'Department',
            dataIndex: 'Department',
            editable: true,
            width: 180
        },
        {
            title: 'VALUE STREAM',
            key: 'ValueStream',
            dataIndex: 'ValueStream',
            editable: true,
            width: 180
        },
        {
            title: 'LOCATION',
            key: 'Location',
            dataIndex: 'Location',
            editable: true,
            width: 180
        },
        {
            title: 'CUSTOMER',
            key: 'Customer',
            dataIndex: 'Customer',
            editable: true,
            width: 180,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'PROJECT',
            key: 'Project',
            dataIndex: 'Project',
            editable: true,
            width: 180
        },
        {
            title: 'WORKER',
            key: 'Worker_code',
            dataIndex: 'Worker_code',
            editable: true,
            width: 180
        },
        {
            title: 'COST CENTER',
            key: 'CostCenter',
            dataIndex: 'CostCenter',
            editable: true,
            width: 180
        },
        // {
        //     title: 'FIRST WEEK',
        //     key: 'First Week',
        //     dataIndex: 'First Week',
        //     // editable: true,
        //     width: 150
        // },
        {
            title: 'ACTION',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        {record.Id === NewRecordKey ? (
                            <Popconfirm
                                title="Sure to Add?"
                                placement="topRight"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => handleAddNewRecord(record)}
                            >
                                <PlusOutlined style={{ marginRight: "8px", color: "green", fontSize: 14 }} />
                            </Popconfirm>
                        ) : (
                            <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
                                onCancel={cancel}>
                                <Typography.Link
                                    style={{
                                        marginRight: 8,
                                    }}
                                >
                                    <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                </Typography.Link>
                            </Popconfirm>)}
                        <Typography.Link onClick={() => cancel(record)}>
                            <CloseOutlined style={{ color: "red" }} />
                        </Typography.Link>

                    </span>
                ) : (
                    <div>
                        <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
                            <Image
                                src="/Images/editicon.svg"
                                style={{
                                    border: "none",
                                    width: "100% ",
                                    marginRight: 5
                                }}
                                showPreviewIcon={false}
                                preview={false}
                            />
                        </Typography.Link>
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteGridRow(record.Id)}
                            okText="Yes"
                            cancelText="No">
                            <Typography.Link disabled={editingKey !== ''} >
                                <Image
                                    src="/Images/deleteicon.svg"
                                    style={{
                                        border: "none",
                                        width: "100% ",
                                        marginLeft: 5
                                    }}
                                    showPreviewIcon={false}
                                    preview={false}
                                />
                            </Typography.Link>
                        </Popconfirm>
                    </div>

                );
            },
        },] :
            cols ? [
                {
                    title: 'ENTITY',
                    key: 'Entity',
                    dataIndex: 'Entity',
                    width: 150,
                    editable: true,
                },
                {
                    title: 'CONTRACT VENDOR NAME',
                    key: 'Contract_Vendor_Name',
                    dataIndex: 'Contract_Vendor_Name',
                    editable: true,
                    width: 250,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    ),
                    ...filterProps()
                },
                {
                    title: 'PORTAL',
                    key: 'Portal',
                    dataIndex: 'Portal',
                    editable: true,
                    width: 190,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    ),
                },
                {
                    title: 'FIRST NAME',
                    key: 'First_Name',
                    dataIndex: 'First_Name',
                    editable: true,
                    width: 200,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    )
                },
                {
                    title: 'MIDDLE NAME',
                    key: 'Middle_Name',
                    dataIndex: 'Middle_Name',
                    editable: true,
                    width: 200,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    )
                },
                {
                    title: 'LAST NAME',
                    key: 'Last_Name',
                    dataIndex: 'Last_Name',
                    editable: true,
                    width: 150,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    )
                },
                {
                    title: 'TIME SHEET NAME',
                    key: 'Timesheert_Name',
                    dataIndex: 'Timesheet_Name',
                    editable: true,
                    width: 180,
                    ellipsis: true,
                    render: (text, record, index) => (
                        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                    )
                },
                {
                    title: 'PROJECT START',
                    key: 'Project_Start',
                    width: 180,
                    render: (_, record) => {
                        const editable = isEditing(record);
                        return editable ? (
                            <span>
                                <DatePicker value={fromDate} onChange={changeStartDate} format={"MM-DD-YYYY"} />
                            </span>
                        ) : (
                            <div>
                                {record.Project_Start}
                            </div>
                        );
                    },
                },
                {
                    title: 'PROJECT END',
                    key: 'Project_End',
                    width: 180,
                    render: (_, record) => {
                        const editable = isEditing(record);
                        return editable ? (
                            <span>
                                <DatePicker value={toDate} onChange={changeEndDate} format={"MM-DD-YYYY"} />
                            </span>
                        ) : (
                            <div>
                                {record.Project_End}
                            </div>
                        );
                    },
                },
                {
                    title: 'NET',
                    key: 'Net',
                    dataIndex: 'Net',
                    editable: true,
                    width: 180
                },
                {
                    title: 'PAY RATE',
                    key: 'Pay_rate',
                    dataIndex: 'Pay_rate',
                    editable: true,
                    width: 180
                },
                {
                    title: 'OT PAY RATE',
                    key: 'OT_Payrate',
                    dataIndex: 'OT_Payrate',
                    editable: true,
                    width: 180
                },
                {
                    title: 'METHOD OF PAYMENT',
                    key: 'Method_of_Payment',
                    dataIndex: 'Method_of_Payment',
                    editable: true,
                    width: 180
                },
                {
                    title: 'CURRENCY',
                    key: 'Currency',
                    dataIndex: 'Currency',
                    editable: true,
                    width: 180
                },
                {
                    title: 'ACTION',
                    dataIndex: 'action',
                    fixed: 'right',
                    width: 100,
                    render: (_, record) => {
                        const editable = isEditing(record);
                        return editable ? (
                            <span>
                                {record.Id === NewRecordKey ? (
                                    <Popconfirm
                                        title="Sure to Add?"
                                        placement="topRight"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => handleAddNewRecord(record)}
                                    >
                                        <PlusOutlined style={{ marginRight: "8px", color: "green", fontSize: 14 }} />
                                    </Popconfirm>
                                ) : (
                                    <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
                                        onCancel={cancel}>
                                        <Typography.Link
                                            style={{
                                                marginRight: 8,
                                            }}
                                        >
                                            <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                        </Typography.Link>
                                    </Popconfirm>)}
                                <Typography.Link onClick={() => cancel(record)}>
                                    <CloseOutlined style={{ color: "red" }} />
                                </Typography.Link>

                            </span>
                        ) : (
                            <div>
                                <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
                                    <Image
                                        src="/Images/editicon.svg"
                                        style={{
                                            border: "none",
                                            width: "100% ",
                                            marginRight: 5
                                        }}
                                        showPreviewIcon={false}
                                        preview={false}
                                    />
                                </Typography.Link>
                                <Popconfirm
                                    title="Are you sure want to delete?"
                                    onConfirm={() => deleteGridRow(record.Id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Typography.Link disabled={editingKey !== ''} >
                                        <Image
                                            src="/Images/deleteicon.svg"
                                            style={{
                                                border: "none",
                                                width: "100% ",
                                                marginLeft: 5
                                            }}
                                            showPreviewIcon={false}
                                            preview={false}
                                        />
                                    </Typography.Link>
                                </Popconfirm>
                            </div>

                        );
                    },
                },]
                :
                //--------------------------------------------------------------
                [
                    {
                        title: 'VENDOR CODE',
                        key: 'Vendor_Code',
                        dataIndex: 'Vendor_Code',
                        editable: true,
                        width: 200,
                        ellipsis: true,
                        render: (text, record, index) => (
                            <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                        ),
                    },
                    {
                        title: 'LEDGER CODE',
                        key: 'Ledger_Code',
                        dataIndex: 'Ledger_Code',
                        editable: true,
                        width: 200,
                        ellipsis: true,
                        render: (text, record, index) => (
                            <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                        ),
                    },
                    // {
                    //     title: 'MAIN ACCOUNT',
                    //     key: 'Main_Account',
                    //     dataIndex: 'Main_Account',
                    //     editable: true,
                    //     width: 180
                    // },
                    {
                        title: 'BUSINESS UNIT',
                        key: 'BusinessUnit',
                        dataIndex: 'BusinessUnit',
                        editable: true,
                        width: 180
                    },
                    {
                        title: 'DEPARTMENT',
                        key: 'Department',
                        dataIndex: 'Department',
                        editable: true,
                        width: 180
                    },
                    {
                        title: 'VALUE STREAM',
                        key: 'ValueStream',
                        dataIndex: 'ValueStream',
                        editable: true,
                        width: 180
                    },
                    {
                        title: 'LOCATION',
                        key: 'Location',
                        dataIndex: 'Location',
                        editable: true,
                        width: 180
                    },
                    {
                        title: 'CUSTOMER',
                        key: 'Customer',
                        dataIndex: 'Customer',
                        editable: true,
                        width: 180,
                        ellipsis: true,
                        render: (text, record, index) => (
                            <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
                        )
                    },
                    {
                        title: 'PROJECT',
                        key: 'Project',
                        dataIndex: 'Project',
                        editable: true,
                        width: 180
                    },
                    {
                        title: 'WORKER',
                        key: 'Worker_code',
                        dataIndex: 'Worker_code',
                        editable: true,
                        width: 180,
                        ...filterProps()
                    },
                    {
                        title: 'COST CENTER',
                        key: 'CostCenter',
                        dataIndex: 'CostCenter',
                        editable: true,
                        width: 180
                    },
                    // {
                    //     title: 'FIRST WEEK',
                    //     key: 'First Week',
                    //     dataIndex: 'First Week',
                    //     // editable: true,
                    //     width: 150
                    // },
                    {
                        title: 'ACTION',
                        dataIndex: 'action',
                        fixed: 'right',
                        width: 100,
                        render: (_, record) => {
                            const editable = isEditing(record);
                            return editable ? (
                                <span>
                                    {record.Id === NewRecordKey ? (
                                        <Popconfirm
                                            title="Sure to Add?"
                                            placement="topRight"
                                            okText="Yes"
                                            cancelText="No"
                                            onConfirm={() => handleAddNewRecord(record)}
                                        >
                                            <PlusOutlined style={{ marginRight: "8px", color: "green", fontSize: 14 }} />
                                        </Popconfirm>
                                    ) : (
                                        <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
                                            onCancel={cancel}>
                                            <Typography.Link
                                                style={{
                                                    marginRight: 8,
                                                }}
                                            >
                                                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                            </Typography.Link>
                                        </Popconfirm>)}
                                    <Typography.Link onClick={() => cancel(record)}>
                                        <CloseOutlined style={{ color: "red" }} />
                                    </Typography.Link>

                                </span>
                            ) : (
                                <div>
                                    <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
                                        <Image
                                            src="/Images/editicon.svg"
                                            style={{
                                                border: "none",
                                                width: "100% ",
                                                marginRight: 5
                                            }}
                                            showPreviewIcon={false}
                                            preview={false}
                                        />
                                    </Typography.Link>
                                    <Popconfirm
                                        title="Are you sure want to delete?"
                                        onConfirm={() => deleteGridRow(record.Id)}
                                        okText="Yes"
                                        cancelText="No">
                                        <Typography.Link disabled={editingKey !== ''} >
                                            <Image
                                                src="/Images/deleteicon.svg"
                                                style={{
                                                    border: "none",
                                                    width: "100% ",
                                                    marginLeft: 5
                                                }}
                                                showPreviewIcon={false}
                                                preview={false}
                                            />
                                        </Typography.Link>
                                    </Popconfirm>
                                </div>

                            );
                        },
                    },
                ]

    const handleAddNewRecord = async (props) => {
        try {
            let currentRowData = await form.getFieldsValue();
            if (!currentRowData.First_Name || !currentRowData.Last_Name || !currentRowData.Worker_code) {
                ErrorMessage("Please enter First name, Last name and Worker code");
                return;
            }
            var newStart = "";
            if (startDate !== undefined) {
                const newD = parseInt(startDate.getMonth() + 1) + '/' + parseInt(startDate.getDate()) + '/' + parseInt(startDate.getFullYear());
                newStart = newD;
            }
            var newEnd = "";
            if (toDate !== undefined) {
                const newD = parseInt(endDate.getMonth() + 1) + '/' + parseInt(endDate.getDate()) + '/' + parseInt(endDate.getFullYear());
                newEnd = newD;
            }
            const data = {
                "id": currentRowData.Id,
                "Vendor_Code": currentRowData.Vendor_Code,
                "ledger_Code": currentRowData.Ledger_Code,
                "main_Account": currentRowData.Main_Account,
                "businessUnit": currentRowData.BusinessUnit,
                "department": currentRowData.Department,
                "valueStream": currentRowData.ValueStream,
                "location": currentRowData.Location,
                "customer": currentRowData.Customer,
                "project": currentRowData.Project,
                "worker_code": currentRowData.Worker_code,
                "costCenter": currentRowData.CostCenter,
                "entity": currentRowData.Entity,
                "contract_Vendor_Name": currentRowData.Contract_Vendor_Name,
                "portal": currentRowData.Portal,
                "first_Name": currentRowData.First_Name,
                "middle_Name": currentRowData.Middle_Name,
                "last_Name": currentRowData.Last_Name,
                "timesheet_Name": currentRowData.Timesheet_Name,
                "project_Start": newStart,
                "project_End": newEnd,
                "net": currentRowData.Net,
                "pay_rate": currentRowData.Pay_rate,
                "method_of_Payment": currentRowData.Method_of_Payment,
                "currency": currentRowData.Currency
            }
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const url = `${BaseUrl}_1099_Contract_Accounting/AddRecord`
            const response = await axios.post(url, data, config)
            if (response.data.statusCode == 200) {
                const res = await getAccountsCubeData()
                if (res !== null && res.length > 0) {
                    setGriddata(res)
                }
                SuccessMessage(response.data.message);
            }
            else if (response.data.statusCode == 500) {
                setGriddata(oldData)
                ErrorMessage(response.data.message)
            }
            else {
                setGriddata(oldData)
                ErrorMessage("Cannot able to add, try again")
            }
            setEditingKey("");
            setFromDate();
            setTodate()
            setStartDate()
            setEndDate()
            setAllCols(false)
        }
        catch {
            setGriddata(oldData)
            setFromDate()
            setTodate()
            setStartDate()
            setEndDate()
            setAllCols(false)
            ErrorMessage("Cannot able to add, please try again")
        }
    }
    const AddNewRecord = async () => {
        setAllCols(true)
        if (editingKey === "") {
            let NewRecordArray = {};
            for (let index in columns) {
                NewRecordArray[columns[index].dataIndex] = "";
            }
            NewRecordArray.Id = "0";
            setOldData([...griddata]);
            setGriddata([NewRecordArray, ...griddata]);
            form.resetFields(); 
            form.setFieldsValue({ ...NewRecordArray });
            setNewRecordKey("0");
            setEditingKey("0");
        } else {
            InfoMessage("Please save/discard the record");
        }
    }
    const edit = (record) => {
        setAllCols(true)
        let formattedStartDate = "";
        let formattedEndDate = "";
        if (record.Project_Start !== undefined) {
            if (record.Project_Start !== "") {
                const defaultValue = dayjs(record.Project_Start, 'M/D/YYYY');
                setFromDate(defaultValue)
                setStartDate("")
                const [month, day, year] = record.Project_Start.split('/');
                // Convert to integer to remove leading zeros and rearrange to M/D/YYYY format
                formattedStartDate = `${parseInt(month)}/${parseInt(day)}/${year}`;
                // rowData.Project_Start = formattedDate;
            }
        }
        if (record.Project_End !== undefined) {
            if (record.Project_End !== "") {
                const defaultEndValue = dayjs(record.Project_End, 'M/D/YYYY');
                setTodate(defaultEndValue)
                setEndDate("")
                const [month, day, year] = record.Project_End.split('/');
                // Convert to integer to remove leading zeros and rearrange to M/D/YYYY format
                formattedEndDate = `${parseInt(month)}/${parseInt(day)}/${year}`;
            }
        }
        setRowData({ ...record, Project_Start: formattedStartDate, Project_End: formattedEndDate })
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    }
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };
    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    const editTableRowData = async (props) => {
        try {
            let currentRowData = await form.getFieldValue();
            const tempPS = currentRowData.Project_Start
            const tempPE = currentRowData.Project_End
            if (startDate !== undefined) {
                if (startDate !== "") {
                    const newD = parseInt(startDate.getMonth() + 1) + '/' + parseInt(startDate.getDate()) + '/' + parseInt(startDate.getFullYear());
                    currentRowData.Project_Start = newD;
                }
                else if (startDate === "") {
                    const [month, day, year] = currentRowData.Project_Start.split('/');
                    const newProjectStart = `${parseInt(month)}/${parseInt(day)}/${year}`;
                    currentRowData.Project_Start = newProjectStart;
                }
            }
            else if (startDate === undefined) {
                currentRowData.Project_Start = ""
            }
            if (endDate !== undefined) {
                if (endDate !== "") {
                    const newD = parseInt(endDate.getMonth() + 1) + '/' + parseInt(endDate.getDate()) + '/' + parseInt(endDate.getFullYear());
                    currentRowData.Project_End = newD;
                }
                else if (endDate === "") {
                    const [month, day, year] = currentRowData.Project_End.split('/');
                    const newProjectEnd = `${parseInt(month)}/${parseInt(day)}/${year}`;
                    currentRowData.Project_End = newProjectEnd;
                }
            }
            else if (endDate === undefined) {
                currentRowData.Project_End = ""
            }
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                if(currentRowData.First_Name !== "" && currentRowData.Last_Name !== "" && currentRowData.Worker_code !== ""){
                    const data = {
                        "id": currentRowData.Id,
                        "Vendor_Code": currentRowData.Vendor_Code,
                        "ledger_Code": currentRowData.Ledger_Code,
                        "main_Account": currentRowData.Main_Account,
                        "businessUnit": currentRowData.BusinessUnit,
                        "department": currentRowData.Department,
                        "valueStream": currentRowData.ValueStream,
                        "location": currentRowData.Location,
                        "customer": currentRowData.Customer,
                        "project": currentRowData.Project,
                        "worker_code": currentRowData.Worker_code,
                        "costCenter": currentRowData.CostCenter,
                        "entity": currentRowData.Entity,
                        "contract_Vendor_Name": currentRowData.Contract_Vendor_Name,
                        "portal": currentRowData.Portal,
                        "first_Name": currentRowData.First_Name,
                        "middle_Name": currentRowData.Middle_Name,
                        "last_Name": currentRowData.Last_Name,
                        "timesheet_Name": currentRowData.Timesheet_Name,
                        "project_Start": currentRowData.Project_Start,
                        "project_End": currentRowData.Project_End,
                        "net": currentRowData.Net,
                        "pay_rate": currentRowData.Pay_rate,
                        "oT_Payrate": currentRowData.OT_Payrate,
                        "method_of_Payment": currentRowData.Method_of_Payment,
                        "currency": currentRowData.Currency
                    }
                    const updateresponse = await updateAccountingCubeRow(data)
                    if (updateresponse.data.statusCode === 200) {
                        const res = await getAccountsCubeData()
                        if (res !== null && res.length > 0) {
                            setGriddata(res)
                        }
                        SuccessMessage(updateresponse.data.message)
                    }
                    else if (updateresponse.data.statusCode === 500) {
                        InfoMessage(updateresponse.data.message)
                    }
                    else {
                        ErrorMessage("Cannot able to update, please try again")
                    }
                    setEditingKey("");
                    setNewRecordKey("");
                    setFromDate()
                    setTodate()
                    setStartDate()
                    setEndDate()
                    setAllCols(false)
                    form.resetFields();
                    // form.setFieldsValue({})
                }
                else{
                    InfoMessage("First name or Last name or Worker cannot be empty")
                }
            }
            else {
                currentRowData.Project_Start = tempPS
                currentRowData.Project_End = tempPE
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch (err) {
            setFromDate()
            setTodate()
            setStartDate()
            setEndDate()
            setAllCols(false)
            // form.setFieldsValue({})
            return err
        }
    }
    const cancel = (record) => {
        if (record.Id === NewRecordKey) {
            setGriddata(oldData);
            setEditingKey("");
            setNewRecordKey("");
            setFromDate()
            setTodate()
            setStartDate()
            setEndDate()
            setAllCols(false)
            form.resetFields();
            // form.setFieldsValue({})
        } else {
            setEditingKey("");
            setNewRecordKey("");
            setFromDate()
            setTodate()
            setStartDate()
            setEndDate()
            setAllCols(false)
            form.resetFields();
            // form.setFieldsValue({})
        }
    }
    const deleteGridRow = async (id) => {
        try {
            const stringNumber = id.toString();
            const idSelected = [stringNumber]
            let url = `${BaseUrl}_1099_Contract_Accounting/DeleteRecord`;
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            };
            const config = {
                headers: headers,
                data: idSelected
            };
            const res = await axios.delete(url, config)
            if (res.data.statusCode === 200) {
                const filteredData = griddata.filter((item) => item.Id !== id);
                setGriddata(filteredData)
                SuccessMessage(res.data.message)
            }
            else if (res.data.statusCode === 500) {
                ErrorMessage(res.data.message)
            }
            else {
                ErrorMessage("Cannot able to delete, please try again")
            }
            setFromDate()
            setTodate()
            setStartDate()
            setEndDate()
        }
        catch {
            ErrorMessage("Cannot able to delete, please try again")
        }
    }
    const deleteAllRows = async () => {
        try {
            let url = `${BaseUrl}_1099_Contract_Accounting/DeleteRecord`;
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            };
            const config = {
                headers: headers,
                data: selectedRowKeys
            };
            const res = await axios.delete(url, config)
            if (res.data.statusCode === 200) {
                const filteredData = griddata.filter(item => !selectedRowKeys.includes(item.Id));
                setGriddata(filteredData)
                setSelectedRowKeys([])
                SuccessMessage(res.data.message)
            }
            else if (res.data.statusCode === 500) {
                ErrorMessage(res.data.message)
            }
            else {
                ErrorMessage("Cannot able to delete, please try again")
            }
        }
        catch {
            ErrorMessage("Cannot able to delete, please try again")
        }
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const setColumnstrue = () => { setCols(true) }
    const setColumnsFalse = () => { setCols(false) }
    return (<>
        <div className="addrow-row">
            <Button className="add-row-1099" onClick={() => AddNewRecord()}>Add New Record<PlusOutlined /></Button>
            <Input
                placeholder="Portal Name \ First Name \ Last Name \ Worker Code \ Vendor Name"
                className="MFten-searchrow"
                // style={{ borderColor: "#3B52DF", color: "#3B52DF" }}
                onChange={(e) => setSearchRow(e.target.value)}
                allowClear
                suffix={
                    <SearchOutlined
                        style={{ color: "#7185FF", justifyContent: "space-between" }}
                    />
                }
            />
        </div>
        <div className="ten99-row2">
            <div className={cols ? "row2-col1" : "row2-column1"} onClick={setColumnstrue}>
                {selectedRowKeys.length > 0 ? <div className="deleteall-image">
                    <Popconfirm
                        title="Are you sure want to delete?"
                        onConfirm={() => deleteAllRows()}
                        onCancel={() => setSelectedRowKeys([])}
                        okText="Yes"
                        cancelText="No">
                        <DeleteOutlined style={{
                            border: "none",
                            width: "100% ",
                            marginLeft: 8,
                            cursor: "pointer"
                        }} />
                        {/* <Image
                            src="./Images/deleteicon.svg"
                            style={{
                                border: "none",
                                width: "100% ",
                                marginLeft: 8,
                                cursor: "pointer"
                            }}
                            showPreviewIcon={false}
                            preview={false}
                        /> */}
                    </Popconfirm>
                </div> : <div style={{ width: 40 }}></div>}
                <div className="contract-cube">Contract Cube</div>
            </div>
            <div className={cols ? "row2-column2" : "row2-col2"} onClick={setColumnsFalse}>Accounting Cube</div>
        </div>
        <div className={griddata.length > 0 ? "ten99-table-class" : "ten99-empty-table"}>
            {
                tableLoader ?
                    <Spin tip="Loading...">
                        <Form form={form} component={false}>
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={originalData.map(item => ({ ...item, key: item.Id }))}
                                components={{ body: { cell: EditableCell, }, }}
                                bordered
                                rowSelection={rowSelection}
                                scroll={{ x: "max-content" }}
                            // pagination
                            /> </Form> </Spin> :
                    griddata.length > 0 ? < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.Id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            rowSelection={rowSelection}
                            scroll={{ x: 1500, y: 400 }}
                        />
                    </Form> : < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.Id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            rowSelection={rowSelection}
                            scroll={{ x: 400, y: 400 }}
                        />
                    </Form>
            }
        </div>
        <div className="crawl-prepare-row">
            {/* <Button className="crawl-prepare-button">Crawl & Prepare</Button> */}
        </div>
    </>)
}
export default TenNinetyNineTable;